import { render, staticRenderFns } from "./DinnerAccountView.vue?vue&type=template&id=f1ef1012&"
import script from "./DinnerAccountView.vue?vue&type=script&lang=js&"
export * from "./DinnerAccountView.vue?vue&type=script&lang=js&"
import style0 from "./DinnerAccountView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports